import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const SkypeLogoIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M1894 1151q35 63 53 132t19 142q0 116-44 218t-120 177-178 120-218 44q-75 0-147-20t-138-58q-26 3-53 5t-53 2q-122 0-235-31t-212-89-180-138-139-179-90-212-32-236q0-32 3-64t8-65q-36-63-55-133T64 623q0-116 44-218t120-177 179-120 218-44q78 0 153 21t142 63q24-2 47-3t48-2q122 0 235 31t212 89 180 138 139 179 90 212 32 236q0 31-2 61t-7 62zm-519 94q0-64-21-112t-57-84-81-62-93-47-93-39-81-36-57-41-22-52q0-29 14-48t36-30 47-17 50-5q27 0 49 3t44 9 43 14 46 19q25 10 47 10 43 0 67-28t25-70q0-33-16-56t-43-40-61-27-68-15-67-7-56-2q-68 0-138 16t-127 53-93 92-37 135q0 63 21 110t57 83 81 62 93 48 93 39 81 38 57 43 22 55q0 31-13 51t-33 31-46 15-51 5q-47 0-82-11t-64-25-56-25-57-12q-44 0-72 25t-29 71q0 36 19 62t49 45 70 30 78 18 75 9 63 3q73 0 143-15t124-51 87-94 33-143z" />
    </svg>
  ),
  displayName: 'SkypeLogoIcon',
});

export default SkypeLogoIcon;
